/* eslint-disable object-curly-newline */
/* eslint-disable linebreak-style */
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions } from '../../../Actions';
import {
	ExpirationDetails,
	GeneralDetails,
	InventoryParams,
	TrackingParameters,
} from '../../../Components/Forms/Inventory Sku';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTab,
	StyledTabs,
	TabPanel,
} from '../../../Components/StyledTabs';
import { generateDisabledProps, history, isEmpty } from '../../../Helpers';
import InventorySkuConfig from './inventorySku.config';

const TABS = [
	'GENERAL DETAILS',
	'QUALITY PARAMETERS',
	'TRACKING PARAMETERS',
	'EXPIRATION DETAILS',
];

const InventorySkuViewPage = (props) => {
	const { fetchInventoruSku, data, deleteInventoruSku, breadcrumbs } = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(InventorySkuConfig.initialState.fields),
	});
	const SkuId = useRouteMatch().params.id;
	useEffect(() => {
		fetchInventoruSku({
			entity: 'INVENTORY_SKU',
			req: {
				params: {
					id: SkuId,
				},
			},
			method: 'VIEW',
		});
	}, []);

	useEffect(() => {
		if (!isEmpty(data)) {
			setState(InventorySkuConfig.serializer(state, data));
		}
	}, [data]);

	const { activeTab, fields } = state;

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return <GeneralDetails isDisabled fields={fields} />;
			case 1:
				return <InventoryParams fields={fields} />;
			case 2:
				return <TrackingParameters fields={fields} />;
			case 3:
				return <ExpirationDetails fields={fields} />;
			default:
				return <></>;
		}
	};

	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};
	const handleDelete = () => {
		const splitURL = url.split('/view');
		deleteInventoruSku({
			entity: 'INVENTORY_SKU',
			req: {
				params: {
					id: SkuId,
				},
			},
			method: 'DELETE',
		});
		history.push(splitURL[0]);
	};
	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Inventory Sku'
				handleEdit={redirectToEdit}
				handleDelete={handleDelete}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${state.fields.skuName}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						<fieldset
							{...generateDisabledProps(true)}
							className='form-fieldset row'
							style={{
								alignItems: 'flex-start',
							}}
						>
							{renderInfo(idx)}
						</fieldset>
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.INVENTORY_SKU.data.VIEW;
	return {
		data,
	};
};

const mapDispatchToProps = {
	fetchInventoruSku: formActions.gateway,
	deleteInventoruSku: formActions.gateway,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InventorySkuViewPage);
